import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AccountService {

  backendUrl: string = environment.apiUrl;
  url_final: string;

  constructor(private http: HttpClient) { 

  }

  consultarClavesSat(buscar_clave_sat){
    this.url_final = this.backendUrl + "/rmsfe/claves_sat?clave_sat="+buscar_clave_sat
    return this.http.get<any>(this.url_final, {observe: 'response'})
    .pipe(map(response => {
      return response;
    }));
  }

  consultarClaveSat(clave_sat){
    this.url_final = this.backendUrl + "/rmsfe/clave_sat?clave_sat="+clave_sat
    return this.http.get<any>(this.url_final, {observe: 'response'})
    .pipe(map(response => {
      return response;
    }));
  }

  cambiarClaveSat(clave_sat){
    this.url_final = this.backendUrl + "/rmsfe/cambiar_clave_sat_api"
    return this.http.post<any>(this.url_final, { clave_sat })
    .pipe(map(response => {
      return response;
    }));
  }
}
